export class TotalReportModel {
  expensesSum: number;
  incomesSum: number;
}
